import React from 'react';
import { T, TraksConsumer } from '../traks';

const APP_ID = "629187177452594"; // XXX configure? can I share between go/js code?

/*
XXX at the time of writing there doesn't seem to be a way to share/send via the
Facebook app on iOS/Android; ideally, these links would open in the app (which
users are more likely to be using than the respective webpages). There's a
fb:// schema for Facebook, and it opens the app, but I can't get it to do
anything useful like sharing anything. It also appears that the API is
unstable, so that fb:// links that worked in the past no longer works.
*/


function FacebookButton(props) {
	return <a className="ad_facebook_button" target="_blank" href={props.href}>{props.children}</a>;
}

function FacebookMessengerButton(props) {
	return <a className="ad_facebook_messenger_button" target="_blank" href={props.href}>{props.children}</a>;
}

function EmailLinkButton(props) {
	return <a className="ad_email_button" href={props.href}>{props.children}</a>;
}

function EmailClientSendImpl(props) {
	var subject = <T>Let us play a game!</T>;
	var body = <T>Link to the game: </T>;

	subject = props.render_static(subject);
	body = props.render_static(body);

	const href = "mailto:?subject=" + subject + "&body=" + body + encodeURIComponent(props.url);

	return <EmailLinkButton href={href}>Email</EmailLinkButton>;
}

const EmailClientSend = (props) => <TraksConsumer><EmailClientSendImpl {...props}/></TraksConsumer>;

function FacebookShare(props) {
	const href = "https://www.facebook.com/dialog/share" +
		"?app_id=" + APP_ID +
		"&href=" + encodeURIComponent(props.url);
	return <FacebookButton href={href}><T>Share</T></FacebookButton>;
}

function FacebookSend(props) {
	const href = "https://www.facebook.com/dialog/send" +
		"?app_id=" + APP_ID +
		"&link=" + encodeURIComponent(props.url) +
		"&redirect_uri=undefined"; // XXX it seems to want this, and I can't get the window to close after send/cancel like /dialog/share does?
	return <FacebookMessengerButton href={href}><T>Message</T></FacebookMessengerButton>;
}

const FacebookIconLink = (props) => {
	let fb_link = null;
	let span_class = "";
	if(props.span_class) span_class = props.span_class;
	if(fb_link) {
		return (
			<span className={span_class}>
			<a href={fb_link} alt="fb" target="_blank" rel="noopener noreferrer">
				<img alt="fb" className="about_us_social_icons" src="/gfx/logo-facebook-round-0.svg" />
			</a>
			</span>
		);
	} else {
		return null;
	}
}

const InstagramIconLink = (props) => {
	let insta_link = null;
	let span_class = "";
	if(props.span_class) {
		span_class = props.span_class;
	}
	if(insta_link) {
		return (
			<span className={span_class}>
			<a href={insta_link} alt="insta" target="_blank" rel="noopener noreferrer">
				<img alt="insta" className="about_us_social_icons" src="/gfx/logo-instagram-1.svg" />
			</a>
			</span>
		);
	} else {
		return null;
	}
}

const TwitterIconLink = (props) => {
	let twtr_link = null;
	let span_class = "";
	if(props.span_class) span_class = props.span_class;
	if(twtr_link) {
		return (
			<span className={span_class}>
			<a href={twtr_link} alt="insta" target="_blank" rel="noopener noreferrer">
				<img alt="twitter" className="about_us_social_icons" src="/gfx/logo-twitter-0.svg" />
			</a>
			</span>
		);
	} else {
		return null;
	}
}

const LinkedInIconLink = (props) => {
	let li_link = null;
	let span_class = "";
	if(props.span_class) span_class = props.span_class;
	if(li_link) {
		return (
			<span className={span_class}>
			<a href={li_link} alt="insta" target="_blank" rel="noopener noreferrer">
				<img alt="linkedin" className="about_us_social_icons" src="/gfx/logo-linkedin-0.svg" />
			</a>
			</span>
		);
	} else {
		return null;
	}
}

const YouTubeIconLink = (props) => {
	let yt_link = null;
	let span_class = "";
	if(props.span_class) span_class = props.span_class;
	if(yt_link) {
		return (
			<span className={span_class}>
				<a href={yt_link} alt="insta" target="_blank" rel="noopener noreferrer">
					<img alt="youtube" className="about_us_social_icons" src="/gfx/logo-youtube-0.svg" />
				</a>
			</span>
		);
	} else {
		return null;
	}
}

export { EmailClientSend, FacebookSend, FacebookShare, FacebookIconLink, InstagramIconLink, TwitterIconLink, LinkedInIconLink, YouTubeIconLink };



// WEBPACK FOOTER //
// ./src/c/SocialMediaStuff.js